import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M60.7799 27.95C51.2799 4.13995 36.8899 1.77993 33.6899 1.54993V1.52991C33.6899 1.52991 33.5699 1.52992 33.3599 1.53992C33.1499 1.52992 33.0299 1.52991 33.0299 1.52991V1.54993C29.8299 1.77993 15.4299 4.13995 5.9399 27.95C-4.7901 54.8699 7.25991 79.14 7.25991 79.14C7.25991 79.14 13.3699 86.7399 20.3099 85.4199C27.1199 84.1199 27.4199 79.1799 33.3599 78.6799C39.2999 79.1699 39.5999 84.1199 46.4099 85.4199C53.3499 86.7399 59.4599 79.14 59.4599 79.14C59.4599 79.14 71.5099 54.8699 60.7799 27.95Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
